import { render, staticRenderFns } from "./deposit_Admin.vue?vue&type=template&id=c66c28c8&scoped=true&"
import script from "./deposit_Admin.vue?vue&type=script&lang=js&"
export * from "./deposit_Admin.vue?vue&type=script&lang=js&"
import style0 from "./deposit_Admin.vue?vue&type=style&index=0&id=c66c28c8&prod&scoped=true&lang=css&"
import style1 from "./deposit_Admin.vue?vue&type=style&index=1&id=c66c28c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66c28c8",
  null
  
)

export default component.exports